<!-- 组装单手动组装操作 -->
<template>
  <div>
    <div class="search-ctn">
      <div class="search-ctn-left">
        <div class="search-name" v-if="PType == 1">现组装数量</div>
        <div class="search-item" v-if="PType == 1">
          <el-input-number
            size="small"
            v-model.trim="opCount"
            :min="1"
            :max="MaxCount"
          ></el-input-number>
        </div>
        <el-button
         v-if="PType != 2"
          size="small"
          icon="el-icon-box"
          class="search-btn btn-primary"
          @click="submitPack"
          >组装</el-button
        >
        <div class="search-name" style="color: red" v-if="PType == 1 || PType == 0">
          ( 已经对应获取仓库【{{ WarehouseName }}】下的库存数据 )
        </div>
      </div>
    </div>
    <div class="search-ctn" v-if="PType == 1">
      <div class="search-ctn-left">
        <div class="search-name title">套包编号 : {{ apCode }}</div>
        <div class="search-name title">套包名称 : {{ goodName }}</div>
        <div class="search-name title">适用车型 : {{ autoSeries }}</div>
      </div>
    </div>
    <div class="table-ctn">
      <el-table
        v-loading="loading"
        :header-cell-style="{ background: '#F2F6FC' }"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          width="160px"
          prop="APCode"
          label="汽配编码"
          show-overflow-tooltip
          style="position: relative;"
        >
          <template slot-scope="scope">
              {{scope.row.APCode}}
                <div
                  v-if="scope.row.State != 0"
                  class="row-delete"
                >已删除</div>
          </template>      
        </el-table-column>
        <el-table-column
          prop="GoodName"
          label="配件名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="AutoSerise"
          label="适用车型"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="60px"
          prop="Unit"
          label="单位"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="PType == 1 || PType == 2"
          width="80px"
          prop="Count"
          label="单包数量"
        ></el-table-column>
        <el-table-column
          v-if="PType == 0"
          show-overflow-tooltip
          width="80px"
          prop="OrderNeedCount"
          label="整单需求"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-if="PType == 0"
          width="80px"
          prop="PackedCount"
          label="已组数量"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100px"
          prop="Inventory"
          label="现有库存数"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="120px"
          label="组装所需库存数"
        >
          <template slot-scope="scope">
            <div
              v-if="PType == 1"
              :class="{
                'check-class': scope.row.Count * opCount > scope.row.Inventory,
              }"
            >
              {{ scope.row.Count * opCount }}
            </div>
            <div
              v-else
              :class="{
                'check-class': scope.row.Count > scope.row.Inventory,
              }"
            >
              {{ scope.row.Count }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-footer" >

    </div>    
    <el-dialog
      :close-on-click-modal="false"
      title="组装出仓"
      :visible.sync="outVisible"
      width="1000px"
      append-to-body
    >
      <div v-if="outVisible">
        <setOrderPackOut
          :APList="APList"
          :SetId="SetId"
          :SId="SId"
          :WarehouseName="WarehouseName"
          :OpCount="opCount"
          :SetOrderId="SetOrderId"
          @closeDialog="closeOutDialog"
        ></setOrderPackOut>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import setOrderPackOut from "@/components/business/goods/setOrderPackOut";
export default {
  name: "",
  props: ["SetId", "PType", "MaxCount", "SetOrderId", "SId", "WarehouseName"],
  components: {
    setOrderPackOut,
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      loading: false,
      goodName: "",
      apCode: "",
      autoSeries: "",
      inventory: 0,
      opCount: this.MaxCount,
      maxCount: 1,
      outVisible: false,
      searchData: {
        EntpId: userMsg.EntpId,
        SetId: this.SetId,
        SetOrderId: this.SetOrderId,
      },
      tableData: [],
      APList: [],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.loading = true;
      let url = "";
      if (this.PType == 1)
        url = "/api/EntpGoods/GetSetOrderDetailsContainWH";
      else if (this.PType == 2)
        url = "/api/EntpGoods/GetSetDetailsContainWHInEditPage";
      else url = "/api/EntpGoods/GetEnterpriseSetOrderAllGoods";
      this.$util
        .axiosGet({
          url: url,
          data: this.searchData,
          hideLoading: true
        })
        .then((res) => {
          this.loading = false;
          let data = res.data;
          if (!data) data = {};
          this.tableData = data.DetailList;
          this.apCode = data.APCode;
          this.goodName = data.GoodName;
          this.autoSeries = data.AutoSerise;
          this.inventory = data.Inventory;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitPack() {
      if (this.PType == 1) {
        if (this.opCount > 0) {
          //校验
          for (let i = 0; i < this.tableData.length; i++) {
            if (
              this.tableData[i].Count * this.opCount >
              this.tableData[i].Inventory
            ) {
              this.$util.warningMsg("库存数量不足以进行组包");
              return;
            }
          }
          this.APList = this.tableData;
          //弹出出仓层
          this.outVisible = true;
        } else this.$util.warningMsg("请填写正确的数量");
      } else {
        this.APList = this.tableData;
        this.opCount = 0;
        //弹出出仓层
        this.outVisible = true;
      }
    },
    closeOutDialog(refresh=false) {
      this.outVisible = false;
      this.APList = [];
      this.$emit("closeDialog",refresh);
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  font-size: 18px;
}
.check-class {
  color: red;
}
  .row-delete {
    position: absolute;
    padding: 1px 6px;
    top: 0;
    right: 0;
    color: #fff;
    background: #ffcc66;
    border-radius: 12.5px;
  }
</style>